import { waitForElem } from '../../utils/wait_for_elem';
let conferenceNavTab;
waitForElem('.tabs--conference').then(() => {
  if (window.location.search.length > 0 && window.location.hash.length === 0){
    conferenceNavTab = window.location.search;
  } else if (window.location.search.length > 0 && window.location.hash.length > 0) {
    conferenceNavTab = window.location.hash
  } else {
    conferenceNavTab = window.location.hash.substring(1);
  }
  const conf_tab_parsed = new URLSearchParams(conferenceNavTab);
  let active_tab = 'home';
  if (conf_tab_parsed.get('tab') !== null && conf_tab_parsed.get('tab') !== '') {
    active_tab = conf_tab_parsed.get('tab') ?? 'home';
  } else {
    active_tab = 'home';
  }
  // loop through tab links and click the one that matches 'tab' url query parameter.
  // and uncheck the ones that don't.
  const radioButtons = document.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
  radioButtons.forEach((radio) => {
    if (radio.id.indexOf(active_tab) >= 0){
      // If the radio button id contains the passed conference tab hash var
      // then check the radio button.
      radio.checked = true;
      // eslint-disable-next-line
      console.log('found the tab and checked it ' + radio.innerHTML);
    } else {
      // If the radio button id does not contain the passed conference tab hash var uncheck it.
      radio.checked = false;
    }

    radio.addEventListener('change', () => {
      // When a radio button is changed, update the URL with the new tab parameter without reloading the page
      let tab_text = radio.id.trim().toLowerCase();
      // eslint-disable-next-line
      console.log(tab_text.indexOf('-'));
      if (tab_text.indexOf('-') >= 0) {
        const tab_text_array = tab_text.split('-');
        tab_text = tab_text_array[0];
      }
      // eslint-disable-next-line
      console.log('new tab selected: ' + tab_text);
      const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?tab=${tab_text}`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    });
  });
});
